import React from "react";
// UI Framework
import { TableCell } from "@mui/material";
import TimelineIcon from "@mui/icons-material/Timeline";
// Common Components
import { Button, Modal } from "src/Components";
// Local Components
import ChartSearchParamUI from "./ChartSearchParamUI";
// Types
import {
  IAdditional,
  IAdditionalHeaderProps,
} from "src/Tables/TableTemplate/tableTemplate";
import { GoldPositionWatchListTableReport } from "src/Interfaces/goldArbitrage";

function chartDockTitle(row: GoldPositionWatchListTableReport) {
  return (
    [row.srcInstrumentName, row.destInstrumentName].filter(Boolean).join(" / ") ||
    "نمودار"
  );
}

const AdditionalHeader = (_props: IAdditionalHeaderProps) => {
  return <TableCell />;
};

const AdditionalCol: React.FC<{
  row: GoldPositionWatchListTableReport;
  onAction: () => void;
}> = ({ row }) => {
  const [isDetailsModalOpen, setIsDetailsModalOpen] = React.useState(false);

  return (
    <TableCell>
      {isDetailsModalOpen ? (
        <Modal
          UI={<ChartSearchParamUI row={row} />}
          title={chartDockTitle(row)}
          onClose={() => setIsDetailsModalOpen(false)}
          fullScreen
        />
      ) : null}
      <div className="w-24">
        <Button
          onClick={() => setIsDetailsModalOpen(true)}
          text={
            <>
              <TimelineIcon style={{ fontSize: 16, marginLeft: 4 }} />
            </>
          }
          variant="contained"
          className="table-btn"
        />
      </div>
    </TableCell>
  );
};

export const Additional: IAdditional<GoldPositionWatchListTableReport> = {
  getHeader: AdditionalHeader,
  getRow: AdditionalCol,
};
